
export const SiteRoutes = {
  Login: { path: '/login' },
  Register: { path: '/registro'},
  Dashboard: { path: '/dash'},
  Profile: { path: '/perfil'},
  Examenes: { path: '/mis-examenes'},
  AgendaMedica: { path: '/agendas-medicas'},
  Indicadores: { path: '/'}
}

export const MenuOptions = [
  {
    path: "/",
    name: "Indicadores Medicos",
    mini: "IM",
    layout: '/admin',
  },
  {
    path: "/perfil",
    name: "Mi Perfil",
    mini: "MP",
    layout: '/admin',
  },
  {
    path: "/mis-examenes",
    name: "Resultados Examenes",
    mini: "R",
    layout: '/admin',
  },
  {
    path: "/agendas-medicas",
    name: "Agenda Medica",
    mini: "AM",
    layout: '/admin',
  },
  // {
  //   path: "/dash",
  //   name: "Dash",
  //   mini: "D",
  //   layout: '/admin',
  // },
];